module.exports = __webpack_public_path__ + "img/td_T1.4.0e9c2ea0.png";